import { useQuery } from '@tanstack/react-query';
import type { Assignee } from '@kontor/shared';
import { api } from '../../api';

/** Benutzer, denen sich Aufgaben zuweisen lassen, dazu eine Funktion für den Namen zu einer ID */
export function useAssignees() {
  const query = useQuery({
    queryKey: ['assignees'],
    queryFn: async () => (await api<{ data: Assignee[] }>('GET', '/tasks/assignees')).data,
    staleTime: 5 * 60_000,
  });
  const list = query.data ?? [];
  return {
    list,
    isLoading: query.isLoading,
    /** Name zu einer ID. Ein inzwischen deaktivierter oder gelöschter Benutzer steht nicht in der Liste. */
    name: (id: string | null): string | null => (id ? (list.find((a) => a.id === id)?.name ?? null) : null),
  };
}

const dateFormat = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' });

/** JJJJ-MM-TT als Datum in deutscher Schreibweise. Der Tag wird als Mittag gelesen, damit die Zeitzone ihn nicht verschiebt. */
export function formatDate(date: string): string {
  return dateFormat.format(new Date(`${date}T12:00:00`));
}
